import styled from 'styled-components';

const StyledArticlesColumn = styled.div`
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  width: 66.66%;
  margin: 0 auto;
  text-align: center;
  .category-title{
    padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
    text-transform: capitalize;
  }
  .article-row{
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: ${props => props.theme.components_spacing_desk.large}px;
    animation: fadeIn .5s ease-out;
  }
  .article-text{
    flex: 0 0 66%;
    max-width: 66%;
    text-align: left;
  }
  .article-img{
    flex: 0 0 20%;
    max-width: 20%;
  }
  .article-img .box-preview {
    position: relative;
    display: block;
    width: 100%;
    background-size: cover;
    background-position: 50%;
  }
  .article-img .box-preview:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  .category{
    text-transform: uppercase;
    padding: 14px 0;
    margin-bottom: 16px;
    cursor: pointer;
    color: ${ props => props.theme.colors.green_secondary};
  }
  
  .details-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #4D4D4D;
    margin-top: 24px;
    flex-wrap: wrap;
  }
  .detail-col{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-right: 24px;
    margin-bottom: 16px;
  }
  .detail-col p {
    white-space: nowrap;
  }
  .detail-col img {
    margin-right: 8px;
  }
  .load-btn{
    position: relative;
    margin: 0 auto;
    display: inline-flex;
    aling-items: center;
    min-width: 20%;
    color: ${ props => props.theme.colors.green_secondary};
    cursor: pointer;
  }
  .load-btn p{
    margin-right: 16px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
    .articles--col .details-wrapper {
      flex-direction: column;
      text-align: left;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .articles--col .detail-col:nth-child(1){
      margin-bottom: 24px
    }
  }
  @media screen and (max-width: 1023px){
    .category-title{
      padding-top: 0;
      padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
    .category{
      margin-bottom: 8px;
    }
    .article-row{
      margin-bottom: ${props => props.theme.components_spacing_tablet.large}px;
    }
    padding-top: ${ props => props.isIndex ? 0 : props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    width: 100%;
    .article-row{
      flex-direction: column-reverse;
      margin-bottom: ${props => props.theme.components_spacing_mobile.large}px;
    }
    .article-text, .article-img{
      flex: 0 0 100%;
      max-width: 100%
    }
    .article-img{
      margin-bottom: 8px;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${ props => props.isIndex ? 0 : props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }

  @keyframes fadeIn {
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
`;

export {
  StyledArticlesColumn
};

